export const CLIENT_TIME_ZONES = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
] as const;

export type ClientTimeZone = (typeof CLIENT_TIME_ZONES)[number];
